export const carType = {
  '1': {
    value: '1',
    label: '轿车'
  },
  '2': {
    value: '2',
    label: '皮卡车'
  },
  '3': {
    value: '3',
    label: '货车'
  },
  '4': {
    value: '4',
    label: '卡车'
  },
  '5': {
    value: '5',
    label: '搅拌车'
  },
  '6': {
    value: '6',
    label: '泥头车'
  },
  '0': {
    value: '0',
    label: '其他'
  }
}
